import { Option } from '@spike/model';

export const CLIENT_NEW_ACTIVITY_NOTIFICATION_KEY = 'client_new_activity';

export const CLIENT_NEW_ACTIVITY_EMAIL_DEFAULT_CONTENT =
    '<p>🐾 [Business Name] shared a new activity for [Pet Names].</p><p>Check out the latest update in your Pet Parent Portal.</p>';

export const CLIENT_NEW_ACTIVITY_SMS_DEFAULT_CONTENT =
    'Hi [Client Name], [Business Name] shared a new activity for [Pet Names].';

export const CLIENT_NEW_ACTIVITY_FALLBACK_CONTENT: Record<string, string> = {
    [`${CLIENT_NEW_ACTIVITY_NOTIFICATION_KEY}_email`]: CLIENT_NEW_ACTIVITY_EMAIL_DEFAULT_CONTENT,
    [`${CLIENT_NEW_ACTIVITY_NOTIFICATION_KEY}_sms`]: CLIENT_NEW_ACTIVITY_SMS_DEFAULT_CONTENT
};

export const CLIENT_NEW_ACTIVITY_PLACEHOLDERS: Array<Option<string>> = [
    { id: 'pet_names', name: 'Pet Names', description: '[Pet Names]' },
    { id: 'client_first_name', name: 'Client first name', description: '[Client first name]' },
    { id: 'client_name', name: 'Client Name', description: '[Client Name]' },
    { id: 'business_name', name: 'Business Name', description: '[Business Name]' }
];
